
import config from '@/config'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import { getCheckType, checkAdd, getBase } from '@/api/yuangongquan'
export default {
components: { Checker, CheckerItem, Swiper, SwiperItem },
data () {
return {
baseUrl: config.baseUrl,
checkList: [],
checktype: [],
momentsid: this.$route.params.id,
obj: {},
baseObj: {}
}
},
computed: {
userid () {
return this.$store.state.user.userid
}
},
mounted () {
this.getBase()
this.getCheckList()
},
methods: {

getCheckList () {
getCheckType({
addTreeNode: 1
}).then(res => {
this.obj = res.obj
})
},
getBase () {
getBase({ id: this.momentsid }).then(res => {
this.baseObj = res.obj
})
},
submit () {
let checktype = this.checktype.join(';')
checkAdd({
checktype: checktype,
userid: this.userid,
id: this.momentsid
}).then(res => {
this.$vux.toast.text('提交成功')
setTimeout(() => {
this.$router.push({ name: 'yuangongquanList' })
}, 1200)
})
}
}
}
